module.exports = __webpack_public_path__ + "static/media/services-bg-4.39fd14c4.png";